import { render, staticRenderFns } from "./asset2.vue?vue&type=template&id=c7882a5c&scoped=true&"
import script from "./asset2.vue?vue&type=script&lang=js&"
export * from "./asset2.vue?vue&type=script&lang=js&"
import style0 from "./asset2.vue?vue&type=style&index=0&id=c7882a5c&scoped=true&lang=less&"
import style1 from "./asset2.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7882a5c",
  null
  
)

export default component.exports